import { gql } from "@apollo/client";

export const SCAN_FRAGMENT = gql`
  fragment ScanPart on Scan {
    id

    price
    priceVariation

    quantity
    quantityVariation

    sales
    restocking

    ca

    productId
    siteId

    createdAt
  }
`;

export const CREATE_SCAN = gql`
  mutation CreateScanMutation($input: CreateScanInput!) {
    createScan(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_SCAN = gql`
  mutation UpdateScanMutation($id: Int!, $input: UpdateScanInput!) {
    updateScan(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const SCANS = gql`
  query ScansQuery($limit: Int!, $offset: Int!, $where: ScansFiltersInput!) {
    scans(limit: $limit, offset: $offset, where: $where) {
      hasMore
      total
      results {
        ...ScanPart

        site {
          id
          name
        }

        product {
          id
          name
          imgUrl
        }
      }
    }
  }
  ${SCAN_FRAGMENT}
`;

export const SCAN = gql`
  query ScanQuery($id: Int!) {
    scan(id: $id) {
      ok
      error
      result {
        id
        quantity
        price
      }
    }
  }
`;

export const SCANS_BY_PRODUCT = gql`
  query ScansByProductQuery(
    $productId: Int!
    $where: ScansFiltersInput!
    $groupBy: String! # Add the required groupBy argument
  ) {
    scansByProduct(id: $productId, where: $where, groupBy: $groupBy) {
      ok
      error
      results {
        price
        quantity
        salesSum
        restockingSum
        ca
        createdAt
      }
    }
  }
`;
export const SCANS_BY_SITE = gql`
  query ScansBySiteQuery(
    $siteId: Int!
    $where: ScansFiltersInput!
    $groupBy: String! # Add the required groupBy argument
  ) {
    scansBySite(id: $siteId, where: $where, groupBy: $groupBy) {
      ok
      error
      results {
        price
        quantity
        salesSum
        restockingSum
        ca
        createdAt
      }
    }
  }
`;

export const BEST_SELLING_SITE_PRODUCTS = gql`
  query BestSellingSiteProductsQuery(
    $siteId: Int!
    $where: ScansFiltersInput!
    $limit: Int!
    $offset: Int!
    $groupBy: String! # Add the required groupBy argument
    $orderBy: String! # Add the required groupBy argument
  ) {
    bestSellingSiteProducts(
      id: $siteId
      where: $where
      groupBy: $groupBy
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      ok
      error
      results {
        productId

        price
        quantity
        salesSum
        restockingSum

        ca
        createdAt

        productName
        productImgUrl
        productUrl
        productQuantity
      }
      hasMore
    }
  }
`;
